import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: { bg: 'bg-accent-100/80', text: 'text-accent-700', border: 'border-accent-200/60' },
  primary: { bg: 'bg-primary-100/80', text: 'text-primary-700', border: 'border-primary-200/60' },
  secondary: { bg: 'bg-secondary-100/80', text: 'text-secondary-700', border: 'border-secondary-200/60' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            人物合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            热门网红人物完整合集入口，台北娜娜、莫里秀、玩偶姐姐等头部人物全覆盖
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => {
            const colors = colorMap[item.color] || colorMap.primary;
            return (
              <a
                key={item.id}
                href="#cards"
                className={`group flex items-center gap-4 p-4 md:p-5 rounded-xl border ${colors.border} ${colors.bg} hover:shadow-sm transition-all cursor-pointer`}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${colors.bg} ${colors.text}`}>
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400">{item.count} 条内容</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}